import React, { useState, useContext } from 'react'
import { api } from '../api/axios';
import { toast } from 'react-toastify';
import { AuthContext } from '../context/AuthContext';


export default function UpdatesForm() {

    const { setLoading } = useContext(AuthContext);

    const [updateFormData, setUpdateFormData] = useState({
        title: '',
        description: '',
        image: '',
        link: ''
    });

    const handelChangeFormData = async (e) => {
        try {
            const { name, value } = e.target;

            if (e.target.type === 'file') {
                const file = e.target.files[0]

                setUpdateFormData({
                    ...updateFormData,
                    [name]: file
                })
            } else {
                setUpdateFormData({
                    ...updateFormData,
                    [name]: value
                })
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handelRegisterNewUpdates = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const formData = new FormData()

            formData.append('title', updateFormData.title)
            formData.append('description', updateFormData.description)
            formData.append('link', updateFormData.link)
            formData.append('image', updateFormData.image)


            const respons = await api.post('/updates', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            // console.log(respons.data);

            if (respons.status === 201) return toast.success("Updates Created Successfully")
        } catch (error) {

            toast.error("Updates Created Error")
            console.error("Updates Created Error:", error);
        } finally {
            setTimeout(() => {
                setLoading(false)
            }, 1000)
        }

    }

    return (
        <>
            <form onSubmit={handelRegisterNewUpdates}>
                <div className="border-b border-gray-900/10 pb-4 mb-4">
                    <h2 className="text-base font-semibold text-gray-900">Updates Information</h2>

                    <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 ms-5">
                        <div className="sm:col-span-3">
                            <label htmlFor="title" className="block text-sm/6 font-medium text-gray-900">
                                Title <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    id="title"
                                    name="title"
                                    type="text"
                                    value={updateFormData.title}
                                    onChange={handelChangeFormData}
                                    required={true}
                                    className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-3">
                            <label htmlFor="image" className="block text-sm/6 font-medium text-gray-900">
                                File <span className='text-sm text-gray-400'>(optional)</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    id="image"
                                    name="image"
                                    type="file"
                                    onChange={handelChangeFormData}
                                    className=" px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-6">
                            <label htmlFor="description" className="block text-sm/6 font-medium text-gray-900">
                                Description <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-2">
                                <textarea
                                    id="description"
                                    name="description"
                                    type="text"
                                    value={updateFormData.description}
                                    onChange={handelChangeFormData}
                                    required={true}
                                    className=" px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                ></textarea>
                            </div>
                        </div>

                        <div className="sm:col-span-6">
                            <label htmlFor="link" className="block text-sm/6 font-medium text-gray-900">
                                Link <span className='text-sm text-gray-400'>(optional)</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    id="link"
                                    name="link"
                                    type="text"
                                    value={updateFormData.link}
                                    onChange={handelChangeFormData}
                                    className=" px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                />
                            </div>
                        </div>



                    </div>
                    <div className="mt-6 flex items-center justify-end gap-x-6">
                        <button
                            type="submit"
                            className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                        >
                            Save Updates
                        </button>
                    </div>
                </div>



            </form>
        </>
    )
}
